import { theme, parse } from "@config/theme";
import { css } from "linaria";
import { rem } from "polished";
export const container = parse({
  // position: "absolute",
  width: "100%",
  height: "100%"
}, "c1ro50ps");
export const image = parse({
  width: "100%",
  height: "100%"
}, "i1seh4ek");
export const content = parse({
  position: "absolute"
}, "c1ehalz3");

require("./CarouselItem.styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./CarouselItem.styles.ts");